<template>
  <div class="page">
    <Navbar />
    <Banner
      :hasText="true"
      :haSingleImg="true"
      :text="titulos[0]"
      :imagem="require('@/assets/img/events/banner.jpg') "
    />
    <v-container>
      <v-col>
        <v-row>
          <Cards type="evento" :iSingle="false" :informations="eventos" :btnText="titulos[1]" />
        </v-row>
      </v-col>
    </v-container>
    <Footer/>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Banner from "@/components/Banner.vue";
import Footer from "@/components/Footer.vue";
import Cards from "@/components/Cards.vue";
import { getLangValue } from "@/globalFunctions.js";
export default {
  name: "Home",
  components: {
    Navbar,
    Banner,
    Cards,
    Footer
  },
  async mounted() {
    await this.putTitulos();
    var eventos = await this.$store.dispatch("setEventos");
    this.eventos = eventos.eventos;
  },
  data() {
    return {
      eventos: [],
      titulos: []
    };
  },
  methods: {
    putTitulos: async function() {
      var homeAbrir = await getLangValue(
        "Home",
        "Abrir",
        this.$store.getters.language
      );

      var menuEventos = await getLangValue(
        "Menu",
        "Eventos",
        this.$store.getters.language
      );

      this.titulos.push(menuEventos);
      this.titulos.push(homeAbrir);
    }
  }
};
</script>
